module.exports = __webpack_public_path__ + "6898c08a22eda45ef3896aa111b0d3bb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/3/Assets/img2.jpeg
// module id = 1328
// module chunks = 0